import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'

const SearchBox = ({ placeholder, value, onChange }) => {
  return (
    <div className="border border-line bg-white rounded-xl px-3 py-2 flex items-center gap-2 focus-within:border-accent transition-colors">
      <FontAwesomeIcon
        icon={faMagnifyingGlass}
        className="text-[13px] text-muted flex-none"
      />
      <input
        className="w-full text-sm bg-transparent outline-none placeholder:text-muted"
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  )
}

export default SearchBox
